import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-216ed1ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "demand-forecastig"
};
const _hoisted_2 = {
  class: "demand-forecastig-content-top"
};
const _hoisted_3 = {
  class: "demand-forecastig-content-search"
};
const _hoisted_4 = {
  class: "demand-forecastig-content-middle"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "demand-forecastig-content-bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_demand_forecasting_top = _resolveComponent("demand-forecasting-top");
  const _component_app_input = _resolveComponent("app-input");
  const _component_b_overlay = _resolveComponent("b-overlay");
  const _component_error_occured = _resolveComponent("error-occured");
  const _component_demand_forecasting_content = _resolveComponent("demand-forecasting-content");
  const _component_app_pagination = _resolveComponent("app-pagination");
  const _component_demand_forecasting_sidebar = _resolveComponent("demand-forecasting-sidebar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["demand-forecastig-content", {
      blur: $data.dataLoading
    }])
  }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_demand_forecasting_top, {
    selected: $options.selectedFilteredSkus,
    onCreateInventoryOrder: $options.onCreateInventoryOrder,
    onGenerateGoogleSheet: $options.onGenerateGoogleSheet
  }, null, 8, ["selected", "onCreateInventoryOrder", "onGenerateGoogleSheet"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_app_input, {
    modelValue: $data.search,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
    placeholder: "Search on this page...",
    v2: "",
    version: "search",
    debounce: "300",
    onChange: $options.searchItem
  }, null, 8, ["modelValue", "onChange"])])]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(_component_b_overlay, {
    show: true,
    opacity: 0.9,
    rounded: "sm",
    style: _normalizeStyle({
      minHeight: $options.getOverlayHeight ?? '100%'
    })
  }, null, 8, ["style"]), [[_vShow, $options.shouldDisplayLoadingOverLay()]]), $data.errorOccured ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_error_occured, {
    onRetry: $options.refreshPage
  }, null, 8, ["onRetry"])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [$options.dfDataInitialized && !$data.errorOccured ? (_openBlock(), _createBlock(_component_demand_forecasting_content, {
    key: 0,
    items: $options.dfFiltered,
    manualOverrideTaskRunning: $data.manualOverrideTaskRunning,
    selected: $data.selected,
    "dataLoading:": $data.dataLoading,
    sortField: $data.sortField,
    sortDirection: $data.sortDirection,
    settings: $data.currentSettings,
    isSideBarCollapsed: $data.isSideBarCollapsed,
    onSelect: $options.onSelect,
    onSort: $options.onSort,
    onUpdate: $options.onUpdate,
    onSaveProductData: $options.onSaveProductData,
    onClearAllOverrideProductData: $options.onClearAllProductData
  }, null, 8, ["items", "manualOverrideTaskRunning", "selected", "dataLoading:", "sortField", "sortDirection", "settings", "isSideBarCollapsed", "onSelect", "onSort", "onUpdate", "onSaveProductData", "onClearAllOverrideProductData"])) : _createCommentVNode("", true)]))]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_app_pagination, {
    page: $data.page,
    "onUpdate:page": [_cache[1] || (_cache[1] = $event => $data.page = $event), _cache[3] || (_cache[3] = $event => $options.changePage($event))],
    perPage: $data.perPage,
    "onUpdate:perPage": [_cache[2] || (_cache[2] = $event => $data.perPage = $event), _cache[4] || (_cache[4] = $event => $options.changeElements($event))],
    total: _ctx.total_rows
  }, null, 8, ["page", "perPage", "total"])])], 2), $options.selectedSellerAccountId ? (_openBlock(), _createBlock(_component_demand_forecasting_sidebar, {
    key: 0,
    account_id: $options.selectedSellerAccountId,
    onIsSidebarCollapsed: $options.onIsSidebarCollapsed
  }, null, 8, ["account_id", "onIsSidebarCollapsed"])) : _createCommentVNode("", true)]);
}